import { BOOKINGS_APP_DEF_ID, BOOKINGS_CHECKOUT_SECTION_ID, BOOKINGS_SCHEDULER_SECTION_ID } from '../const';
import { isBookingsSectionInstalled } from '../isBookingsSectionInstalled/isBookingsSectionInstalled';
export let ReservedSlug = /*#__PURE__*/function (ReservedSlug) {
  ReservedSlug["DATE_AND_TIME"] = "_select-date-time";
  return ReservedSlug;
}({});
export function getUrlQueryParams(wixCodeApi) {
  return wixCodeApi.location.query;
}
export function queryBuilder(queryParams) {
  const params = [];
  for (const [key, value] of Object.entries(queryParams)) {
    if (value !== undefined && value !== null) {
      params.push([key + "=" + value]);
    }
  }
  return params.length ? "?" + params.join('&') : '';
}
export async function getBookingsRelativeUrl(wixCodeApi) {
  const isBookingCheckoutInstalled = await isBookingsSectionInstalled(wixCodeApi, BOOKINGS_CHECKOUT_SECTION_ID);
  const fullBookingsUrl = (await wixCodeApi.site.getSectionUrl({
    sectionId: isBookingCheckoutInstalled ? BOOKINGS_CHECKOUT_SECTION_ID : BOOKINGS_SCHEDULER_SECTION_ID,
    appDefinitionId: BOOKINGS_APP_DEF_ID
  })).url;
  const baseUrl = wixCodeApi.location.baseUrl;
  if (baseUrl) {
    const urlParts = fullBookingsUrl.split(baseUrl);
    return urlParts.length > 1 ? urlParts[1] : fullBookingsUrl;
  }
  return fullBookingsUrl;
}
export async function getSectionRelativeUrl(wixCodeApi, sectionId) {
  const {
    url: fullBookingsUrl,
    prefix
  } = await wixCodeApi.site.getSectionUrl({
    sectionId,
    appDefinitionId: BOOKINGS_APP_DEF_ID
  });
  if (prefix) {
    return "/" + prefix;
  }
  const baseUrl = wixCodeApi.location.baseUrl;
  if (baseUrl) {
    const urlParts = fullBookingsUrl.split(baseUrl);
    return urlParts.length > 1 ? urlParts[1] : fullBookingsUrl;
  }
  return fullBookingsUrl;
}
export function getSectionUrlParams(wixCodeApi) {
  try {
    const params = {
      ...(getUrlQueryParams(wixCodeApi).appSectionParams ? JSON.parse(decodeURI(getUrlQueryParams(wixCodeApi).appSectionParams)) : {})
    };
    return params;
  } catch (_unused) {
    return {};
  }
}
export function getUrlQueryParamValue(wixCodeApi, key) {
  const params = {
    ...getSectionUrlParams(wixCodeApi),
    ...getUrlQueryParams(wixCodeApi)
  };
  return params[key];
}
export function setUrlQueryParam(_ref) {
  let {
    wixCodeApi,
    key,
    value
  } = _ref;
  if (typeof value !== 'undefined') {
    wixCodeApi.location.queryParams.add({
      [key]: value
    });
  }
}
//# sourceMappingURL=urlUtils.js.map